"use client"

import { SiteConfigProvider } from "@/contexts/site-config"
import { UserChatProvider } from "@/contexts/user-chat"
import { SessionProvider } from "next-auth/react"
import { HydrationProvider } from "react-hydration-provider"

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <HydrationProvider>
      <SessionProvider>
        <SiteConfigProvider>
          <UserChatProvider>{children}</UserChatProvider>
        </SiteConfigProvider>
      </SessionProvider>
    </HydrationProvider>
  )
}
